const content = {
  component: 'PageTypeA',
  cssClass: 'page-welcome',
  meta: {
    title: 'Welcome to the First Edition of Your Tomorrow, Today',
    description: 'Technology such as cloud is enabling businesses to reach their strategic visions.',
    og: {
      type: 'website',
      title: 'How is tech driving innovation?—Read now',
      description: `From pioneering scientific research to agriculture, read their inspiring stories, and learn how the latest 
        innovations can help you achieve your goals.`,
      image: require('../../assets/images/social/og_page1.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'From science to agriculture, learn how technology enables innovation.',
      description: `From enabling world-leading scientific research to innovating commercial agriculture, discover stories of how 
        cutting-edge technology is driving transformation.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_page1.jpg')
    }
  },
  title: 'Welcome to the First Edition of Your Tomorrow, Today',
  heroImage: {
    preload: require('../../assets/images/backgrounds/welcome-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/welcome.jpg')
  },
  sections: [
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          Why Your Tomorrow, Today? Every day, we see our customers realise their business visions through innovation—using secure cloud technology to reach strategic goals more quickly than they ever imagined.
        `,
        type: 'intro'
      }
    },
    { 
      component: 'SectionSeperator', 
      content: {
        image: null
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>Discover how CERN, (the European Organisation for Nuclear Research) maintains strict data security while exploring cloud storage services to analyse the huge amount of data and information their programmes generate daily.</p>
          <p>Learn how a fast-growing organic pesticide business like Marrone Bio manages accelerated growth to expand quickly and profitably at scale.</p>
          <p>Delight in how HelpAge India uses cloud technology to deliver medical supplies and donations to those who need it most in the shortest time possible. This project alone will yield a 14% reduction in operating costs and reduce inventory to near zero. A story that really does bring their tomorrow, today.</p>
          <p>You’ll be amazed by the ingenuity of modern dairy farming giant NADEC—how this company uses cloud to help manage the business impact of an upcoming 2019 forage crop ban. This Saudi Arabian dairy producer manages and ships Sudanese crops with speed and operational efficiency while also cutting costs.</p>
          <p>Each story shows how innovative and forward-thinking organisations can deliver tomorrow, today.</p>
          <p>That’s what we celebrate within Your Tomorrow, Today.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionAuthor', 
      content: {
        author: 'Amanda Jobbins',
        position: 'VP Demand Generation & Marketing EMEA/APAC',
        image: require('../../assets/images/people/amanda-jobbins.png'),
        type: 'author'
      }
    }
  ]



}

export default content;